import { type MessagesState } from './messages-types'
import { AcknowledgeMessageAction, AddMessageAction } from './messages-actions'
import { createReducer } from '@reduxjs/toolkit'

export const initialMessagesState: MessagesState = {
  messages: []
}

export const messagesReducer = createReducer(initialMessagesState, builder => {
  builder.addCase(AddMessageAction, (state, action) => {
    state.messages.push(action.payload.message)
  }).addCase(AcknowledgeMessageAction, (state, action) => {
    state.messages = state.messages.filter((msg) => msg.id !== action.payload.id)
  })
})
